import {EPermissions, ScreenProp} from 'src/app/models'

type TKeys =
  | 'JOB_TUGAS'
  | 'JOB_TUGAS_LIST_ACTIVE'
  | 'JOB_TUGAS_LIST_DRAFT'
  | 'JOB_TUGAS_ADD'
  | 'JOB_TUGAS_DETAIL'
  | 'JOB_TUGAS_EDIT'
  | 'JOB_TUGAS_UPLOAD'

export const JobTugasScreen: Record<TKeys, ScreenProp> = {
  JOB_TUGAS: {
    PATH: '/job/list',
    TITLE: 'Manajemen Tugas',
    TITLE_ALT: 'Manajemen Tugas',
  },
  JOB_TUGAS_LIST_ACTIVE: {
    PATH: '/job/list/active',
    TITLE: 'Manajemen Tugas',
    TITLE_ALT: 'Ringkasan',
    PERMISSION: [EPermissions.JOB_READ],
  },
  JOB_TUGAS_LIST_DRAFT: {
    PATH: '/job/list/draft',
    TITLE: 'Manajemen Tugas',
    TITLE_ALT: 'Draf',
    PERMISSION: [EPermissions.JOB_READ],
  },
  JOB_TUGAS_ADD: {
    PATH: '/job/list/add',
    TITLE: 'Buat Tugas',
    TITLE_ALT: 'Buat',
    PERMISSION: [EPermissions.JOB_CREATE],
  },
  JOB_TUGAS_DETAIL: {
    PATH: '/job/list/detail/:id',
    TITLE: 'Detail Tugas',
    TITLE_ALT: 'Detail Tugas',
    PERMISSION: [EPermissions.JOB_READ],
  },
  JOB_TUGAS_EDIT: {
    PATH: '/job/list/edit/:id',
    TITLE: 'Edit Tugas',
    TITLE_ALT: 'Edit Tugas',
    PERMISSION: [EPermissions.JOB_UPDATE],
  },
  JOB_TUGAS_UPLOAD: {
    PATH: '/job/list/upload',
    TITLE: 'Upload Tugas',
    TITLE_ALT: 'Upload',
    PERMISSION: [EPermissions.JOB_CREATE],
  },
}
